import { getImageUrl } from '@/app/utils';
import { baseURLImg } from '@/services/constants/app';
import Image from 'next/image';
import Link from 'next/link';

interface BlogData {
    blog_id: number;
    blog_title: string;
    blog_description: string;
    meta_description: string;
    blog_image: string;
    category: string;
    created_date: string;
    created_by: string;
}

interface BlogCommonProps {
    blogData: BlogData[];
}

export default function BlogRecentPost({ blogData }: BlogCommonProps) {
    // const getImageUrl = (imageName: string) => {
    //     // Ensure the URL is properly formatted
    //     return `${baseURLImg}Images/${imageName.replace(/^\/+/, '')}`;
    // };

    // Sort blogData in descending order by created_date
    const sortedBlogData = blogData?.sort((a, b) => new Date(a.created_date).getTime() - new Date(b.created_date).getTime());
    return (
        <div className="md:col-span-1 bg-white p-4 rounded-lg shadow-md">
            <h3 className="text-xl text-[#333333] font-semibold mb-2">Latest Posts</h3>
            <ul className="space-y-4">
                <div className=" grid grid-cols-1 md:grid-cols-1 gap-6">
                    {sortedBlogData?.slice(0, 6)?.map((post) => (
                        <article key={post.blog_id} className="">
                            <Link
                                href={`/bond-academy/blog/${post.blog_id}`}
                                className="flex items-center space-x-4 py-4 border-b  border-gray-200 last:border-b-0 group text-sm text-gray-600 hover:text-gray-800 transition-colors"
                            >
                                <div className="flex-shrink-0 w-20 h-20 relative">
                                    <Image
                                        src={post.blog_image ? getImageUrl(post.blog_image) : '/img/PlaceHolder.png'}
                                        alt={post.blog_title}
                                        layout="fill"
                                        objectFit="cover"
                                        className="rounded-md"
                                        unoptimized
                                    />
                                </div>
                                <div className="flex-grow min-w-0">
                                    <p className="text-xs text-gray-500 mb-1">{new Date(post.created_date).toLocaleDateString()}</p>
                                    <h3 className="text-sm text-[#333333] font-semibold mb-1 truncate">{post.blog_title}</h3>
                                    <div
                                        className="text-xs text-gray-600 line-clamp-2"
                                        dangerouslySetInnerHTML={{
                                            __html: post?.blog_description?.replace(/<[^>]*>/g, '').slice(0, 60) + '...',
                                        }}
                                    />
                                </div>
                            </Link>
                        </article>
                    ))}
                </div>
            </ul>
        </div>
    );
}
